import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { authActions } from 'src/auth';
import Button from 'src/views/components/button';
import HeroSection from 'src/views/components/hero-section';
import ContentSection from 'src/views/components/content-section';
import CTA from 'src/views/components/cta';
import Footer from 'src/views/components/footer';

import './sign-in-page.css';


const SignInPage = ({signInWithGithub, signInWithGoogle, signInWithTwitter}) => {
  return (
    <div>
      <HeroSection/>
      <ContentSection/>
      <div style={{marginTop:'-20px'}}>     
      <CTA/>
      </div>

      <Footer/>
    </div>
  );
};

SignInPage.propTypes = {
  signInWithGithub: PropTypes.func.isRequired,
  signInWithGoogle: PropTypes.func.isRequired,
  signInWithTwitter: PropTypes.func.isRequired
};


//=====================================
//  CONNECT
//-------------------------------------

const mapDispatchToProps = {
  signInWithGithub: authActions.signInWithGithub,
  signInWithGoogle: authActions.signInWithGoogle,
  signInWithTwitter: authActions.signInWithTwitter
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(SignInPage)
);



// WEBPACK FOOTER //
// ./src/views/pages/sign-in/sign-in-page.js